(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const slideshows = new WeakMap();

  /* ---------- Vitrin slaytları ---------- */
  function initSlideshow(root) {
    if (slideshows.has(root)) return;
    const slides = $$('[data-dk-slide]', root);
    const dots = $$('[data-dk-go]', root);
    const toggle = $('[data-dk-toggle]', root);
    const speed = (Number(root.dataset.speed) || 7) * 1000;
    let index = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
    let timer = null;
    let paused = root.dataset.autoplay !== 'true' || reduced();
    let hover = false;

    const focusables = slide => $$('a, button, input, select, textarea', slide);
    function render() {
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        if (active) slide.removeAttribute('aria-hidden'); else slide.setAttribute('aria-hidden', 'true');
        focusables(slide).forEach(el => { if (active) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        const bar = dot.querySelector('span');
        if (bar && i === index) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      });
      root.dataset.tone = slides[index]?.classList.contains('dk-slide--light') ? 'light' : 'dark';
      schedule();
    }
    function go(i) { index = (i + slides.length) % slides.length; render(); }
    function schedule() {
      clearTimeout(timer);
      root.classList.toggle('is-paused', paused || hover);
      if (!paused && !hover && slides.length > 1) timer = setTimeout(() => go(index + 1), speed);
    }
    function setPaused(value) {
      paused = value;
      if (toggle) {
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? 'Slaytları başlat' : 'Slaytları durdur');
      }
      schedule();
    }

    root.addEventListener('click', e => {
      if (e.target.closest('[data-dk-next]')) go(index + 1);
      else if (e.target.closest('[data-dk-prev]')) go(index - 1);
      else if (e.target.closest('[data-dk-toggle]')) setPaused(!paused);
      else { const dot = e.target.closest('[data-dk-go]'); if (dot) go(Number(dot.dataset.dkGo)); }
    });
    root.addEventListener('mouseenter', () => { hover = true; schedule(); });
    root.addEventListener('mouseleave', () => { hover = false; schedule(); });
    root.addEventListener('focusin', () => { hover = true; schedule(); });
    root.addEventListener('focusout', e => { if (!root.contains(e.relatedTarget)) { hover = false; schedule(); } });
    root.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { go(index + 1); }
      if (e.key === 'ArrowLeft') { go(index - 1); }
    });
    let startX = null;
    root.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') startX = e.clientX; }, { passive: true });
    root.addEventListener('pointerup', e => {
      if (startX === null) return;
      const dx = e.clientX - startX; startX = null;
      if (Math.abs(dx) > 50) go(index + (dx < 0 ? 1 : -1));
    }, { passive: true });
    document.addEventListener('visibilitychange', () => { if (document.hidden) clearTimeout(timer); else schedule(); });

    if (toggle) toggle.setAttribute('aria-pressed', String(paused));
    const api = { go: i => { setPaused(true); go(i); }, resume: () => setPaused(root.dataset.autoplay !== 'true' || reduced()), stop: () => clearTimeout(timer), slides };
    slideshows.set(root, api);
    render();
  }

  /* ---------- Duyuru mesajları ---------- */
  function initAnnouncement(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const items = $$('.dk-announcement__item', bar);
    if (items.length < 2) return;
    let i = 0, hover = false;
    bar.addEventListener('mouseenter', () => { hover = true; });
    bar.addEventListener('mouseleave', () => { hover = false; });
    setInterval(() => {
      if (hover || document.hidden) return;
      items[i].classList.remove('is-active'); items[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active'); items[i].removeAttribute('aria-hidden');
    }, 4500);
  }

  /* ---------- Üst menü ---------- */
  function measureHeader() {
    const bar = $('.dk-announcement');
    document.documentElement.style.setProperty('--dk-announce-h', (bar ? bar.offsetHeight : 0) + 'px');
  }
  function onScroll() {
    const group = $('.shopify-section-group-header-group:has(.dk-header)') || $('.dk-header')?.parentElement;
    if (group) group.classList.toggle('is-scrolled', window.scrollY > 40);
  }

  function initMega(mega) {
    if (mega.dataset.ready) return;
    mega.dataset.ready = 'true';
    const button = $('.dk-mega__toggle', mega);
    const panel = $('.dk-mega__panel', mega);
    let closeTimer, hoverOpenedAt = 0;
    const set = open => { clearTimeout(closeTimer); button.setAttribute('aria-expanded', String(open)); panel.hidden = !open; };
    button.addEventListener('click', () => {
      // Fareyle yeni açıldıysa tıklama menüyü kapatmasın
      if (!panel.hidden && Date.now() - hoverOpenedAt < 700) return;
      set(panel.hidden);
    });
    const canHover = matchMedia('(hover: hover)').matches;
    if (canHover) {
      mega.addEventListener('mouseenter', () => { if (panel.hidden) hoverOpenedAt = Date.now(); set(true); });
      mega.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => set(false), 160); });
    }
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) { set(false); button.focus(); } });
    document.addEventListener('click', e => { if (!mega.contains(e.target)) set(false); });
    mega.addEventListener('focusout', e => { if (!mega.contains(e.relatedTarget)) set(false); });
  }

  /* ---------- Özellikler ---------- */
  function openFeature(section, id) {
    $$('.dk-feature', section).forEach(item => {
      const btn = $('[data-dk-feature]', item);
      const open = btn.dataset.dkFeature === id;
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
      $('.dk-feature__panel', item).hidden = !open;
    });
    $$('[data-dk-feature-image]', section).forEach(img => img.classList.toggle('is-active', img.dataset.dkFeatureImage === id));
  }
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-dk-feature]');
    if (!btn) return;
    const section = btn.closest('[data-dk-features]');
    if (btn.getAttribute('aria-expanded') === 'true') return;
    openFeature(section, btn.dataset.dkFeature);
    // Mobilde açılan maddeyi (görseli ve yazısıyla) ekrana getir
    if (matchMedia('(max-width: 989px)').matches && section.classList.contains('dk-features--m-panel')) {
      const item = btn.closest('.dk-feature');
      requestAnimationFrame(() => item.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' }));
    }
  });

  /* ---------- Desen testi ---------- */
  // Ürün etiketi yoksa kullanılan varsayılan eşleşmeler. İlk renk/tarz ana özelliktir.
  const QUIZ_FALLBACK = {
    'gun-dogumu': ['sicak', 'mavi', 'doga', 'hediye'],
    'kalpten': ['sicak', 'sembol', 'hediye'],
    'domates': ['sicak', 'doga', 'birlikte'],
    'bereket-eli': ['mavi', 'sembol', 'hediye'],
    'nazar-boncugu': ['mavi', 'sembol', 'hediye'],
    'sukulent': ['dogal', 'doga', 'birlikte'],
    'eli-belinde': ['dogal', 'sicak', 'geometrik', 'sembol'],
    'yesil-dongu': ['dogal', 'geometrik', 'birlikte'],
    'pitrak': ['dogal', 'sicak', 'geometrik'],
    'dugum': ['dogal', 'geometrik', 'sembol'],
    'pusula': ['mavi', 'dogal', 'geometrik']
  };
  const QUIZ_COLORS = ['sicak', 'dogal', 'mavi'];
  const QUIZ_STYLES = ['doga', 'sembol', 'geometrik'];
  const quizState = {};
  const normTr = v => String(v).toLocaleLowerCase('tr').replace(/ı/g, 'i').replace(/ğ/g, 'g').replace(/ş/g, 's').replace(/ç/g, 'c').replace(/ö/g, 'o').replace(/ü/g, 'u');
  const capitalTr = v => v ? v.charAt(0).toLocaleUpperCase('tr') + v.slice(1) : v;
  function quizData() { try { return JSON.parse(document.getElementById('DkQuizData').textContent); } catch (e) { return { text: {}, products: [] }; } }
  function quizAttrs(product) {
    const tagged = (product.tags || []).map(normTr).filter(t => t.indexOf('test-') === 0).map(t => t.slice(5));
    return tagged.length ? tagged : (QUIZ_FALLBACK[product.handle] || []);
  }
  function quizScore(product) {
    const attrs = quizAttrs(product);
    const colors = attrs.filter(a => QUIZ_COLORS.includes(a));
    const styles = attrs.filter(a => QUIZ_STYLES.includes(a));
    let score = 0;
    const ci = colors.indexOf(quizState.color); if (ci === 0) score += 3; else if (ci > 0) score += 2;
    const si = styles.indexOf(quizState.style); if (si === 0) score += 3; else if (si > 0) score += 2;
    if (quizState.who === 'gift' && attrs.includes('hediye')) score += 1;
    if (quizState.who === 'together' && attrs.includes('birlikte')) score += 1;
    return score + Math.random() * 0.5; // eşit puanlı desenler arasında her seferinde farklı sıra
  }
  function quizGo(dialog, step) {
    $$('[data-dk-quiz-step]', dialog).forEach(el => { el.hidden = el.dataset.dkQuizStep !== String(step); });
    const bar = $('[data-dk-quiz-bar]', dialog);
    if (bar) bar.style.width = ({ 1: 10, 2: 42, 3: 74, result: 100 })[step] + '%';
    const heading = $(`[data-dk-quiz-step="${step}"] h2`, dialog);
    if (heading) heading.focus({ preventScroll: true });
    dialog.scrollTop = 0;
  }
  function quizReset(dialog) {
    Object.keys(quizState).forEach(k => delete quizState[k]);
    quizGo(dialog, 1);
  }
  function quizResult(dialog) {
    const data = quizData();
    const text = data.text || {};
    const products = data.products || [];
    if (!products.length) { quizGo(dialog, 1); return; }
    const ranked = products.map(p => ({ p, s: quizScore(p) })).sort((a, b) => b.s - a.s).map(x => x.p);
    const best = ranked[0];
    const together = quizState.who === 'together';
    $$('[data-dk-quiz-link]', dialog).forEach(a => { a.href = best.url + (together ? '?offer=duo' : ''); });
    const img = $('[data-dk-quiz-image]', dialog); img.src = best.image; img.alt = best.title;
    $('[data-dk-quiz-title]', dialog).textContent = best.title;
    const reason = String(text.reason || '{desen}').replace('{renk}', quizState.colorShort || '').replace('{tarz}', quizState.styleShort || '').replace('{desen}', best.title);
    $('[data-dk-quiz-reason]', dialog).textContent = capitalTr(reason.trim());
    $('[data-dk-quiz-price]', dialog).textContent = best.price;
    $('[data-dk-quiz-duo]', dialog).textContent = best.duo ? `${text.unit || ''} ${best.duo}`.trim() : '';
    const note = $('[data-dk-quiz-note]', dialog);
    const noteText = quizState.who === 'gift' ? text.gift : together ? text.together : '';
    note.textContent = noteText || ''; note.hidden = !noteText;
    const add = $('[data-dk-quiz-add]', dialog);
    if (best.single && best.variant) { add.hidden = false; add.dataset.cartAdd = best.variant; } else { add.hidden = true; add.removeAttribute('data-cart-add'); }
    const view = $('[data-dk-quiz-view]', dialog); if (view) view.textContent = together && text.duoLink ? text.duoLink : (text.view || view.textContent);
    const alts = $('[data-dk-quiz-alts]', dialog);
    alts.replaceChildren(...ranked.slice(1, 3).map(p => {
      const a = document.createElement('a'); a.className = 'dk-quiz__alt'; a.href = p.url;
      const im = document.createElement('img'); im.src = p.image; im.alt = ''; im.width = 120; im.height = 150; im.loading = 'lazy';
      const box = document.createElement('span'); const t = document.createElement('strong'); t.textContent = p.title;
      const pr = document.createElement('small'); pr.textContent = p.price; box.append(t, pr); a.append(im, box); return a;
    }));
    $('[data-dk-quiz-alts-wrap]', dialog).hidden = ranked.length < 2;
    quizGo(dialog, 'result');
  }
  document.addEventListener('click', e => {
    if (e.target.closest('[data-open="QuizDialog"]')) { const d = document.getElementById('QuizDialog'); if (d && d.matches('[data-dk-quiz]')) quizReset(d); }
    const dialog = e.target.closest('[data-dk-quiz]');
    if (!dialog) return;
    const answer = e.target.closest('[data-dk-quiz-answer]');
    if (answer) {
      const key = answer.dataset.dkQuizAnswer;
      quizState[key] = answer.dataset.value;
      if (key === 'color') quizState.colorShort = answer.dataset.short || '';
      if (key === 'style') quizState.styleShort = answer.dataset.short || '';
      if (key === 'who') quizGo(dialog, 2); else if (key === 'color') quizGo(dialog, 3); else quizResult(dialog);
      return;
    }
    if (e.target.closest('[data-dk-quiz-back]')) {
      const current = $('[data-dk-quiz-step]:not([hidden])', dialog)?.dataset.dkQuizStep;
      quizGo(dialog, current === '3' ? 2 : 1);
      return;
    }
    if (e.target.closest('[data-dk-quiz-restart]')) quizReset(dialog);
    if (e.target.closest('.dk-quiz__alt, [data-dk-quiz-link]')) dialog.close();
  });

  /* ---------- Ürün galerisi ve ikili alım ---------- */
  document.addEventListener('click', e => {
    const thumb = e.target.closest('[data-gallery-image]');
    if (thumb) {
      const gallery = thumb.closest('[data-dk-gallery]');
      if (gallery) {
        const thumbs = $$('[data-gallery-image]', gallery);
        thumbs.forEach(t => { const on = t === thumb; t.classList.toggle('is-active', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
        const counter = $('[data-dk-gallery-index]', gallery); if (counter) counter.textContent = thumbs.indexOf(thumb) + 1;
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduced() ? 'auto' : 'smooth' });
      }
    }
    const step = e.target.closest('[data-dk-gallery-prev], [data-dk-gallery-next]');
    if (step) stepGallery(step.closest('[data-dk-gallery]'), step.hasAttribute('data-dk-gallery-next') ? 1 : -1);
    const pick = e.target.closest('[data-offer-pick]');
    if (pick) {
      const form = pick.closest('form');
      const input = form && form.querySelector(`[name="offer"][value="${pick.dataset.offerPick}"]`);
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); input.closest('.offer-card')?.scrollIntoView({ block: 'nearest', behavior: reduced() ? 'auto' : 'smooth' }); }
    }
  });
  function stepGallery(gallery, dir) {
    if (!gallery) return;
    const thumbs = $$('[data-gallery-image]', gallery);
    if (!thumbs.length) return;
    const current = Math.max(0, thumbs.findIndex(t => t.classList.contains('is-active')));
    thumbs[(current + dir + thumbs.length) % thumbs.length].click();
  }
  let galleryStartX = null;
  document.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' && e.target.closest('.product-main-image')) galleryStartX = e.clientX; }, { passive: true });
  document.addEventListener('pointerup', e => {
    if (galleryStartX === null) return;
    const dx = e.clientX - galleryStartX; galleryStartX = null;
    if (Math.abs(dx) > 45) stepGallery(e.target.closest('[data-dk-gallery]'), dx < 0 ? 1 : -1);
  }, { passive: true });

  function init(scope = document) {
    $$('[data-dk-slideshow]', scope).forEach(initSlideshow);
    $$('[data-dk-announcement]', scope).forEach(initAnnouncement);
    $$('[data-dk-mega]', scope).forEach(initMega);
    measureHeader();
    onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measureHeader);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();

  /* ---------- Tema düzenleyici ---------- */
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => { $$('[data-dk-slideshow]', e.target).forEach(r => slideshows.get(r)?.stop()); });
  document.addEventListener('shopify:block:select', e => {
    const slide = e.target.closest('[data-dk-slide]');
    if (slide) {
      const root = slide.closest('[data-dk-slideshow]');
      const api = slideshows.get(root);
      if (api) api.go(api.slides.indexOf(slide));
    }
    const feature = e.target.closest('.dk-feature');
    if (feature) openFeature(feature.closest('[data-dk-features]'), $('[data-dk-feature]', feature).dataset.dkFeature);
  });
  document.addEventListener('shopify:block:deselect', e => {
    const root = e.target.closest('[data-dk-slideshow]');
    slideshows.get(root)?.resume();
  });
})();
